























































































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Radio } from '@/components/form'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, numeric } from 'vuelidate/lib/validators'

// models
import { MediumHeavyForm } from '@/models/config'

// constants
import { optionsStatus } from '@/constants'

// utils
import { loading, alerts } from '@/utils'

// services
import { MediumHeavyService } from '@/services/config'

const initItem: MediumHeavyForm = {
    heavy: 0,
    piece: 0,
    rate: 0,
    is_active: true
}

@Component({
    name: 'FormCreateEditMediumHeavy',
    components: {
        Input,
        Radio
    },
    mixins: [validationMixin]
})
export default class FormCreateEditMediumHeavy extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) heavy!: MediumHeavyForm
    @Prop({ type: Number, default: null }) idEdit!: number|null

    optionsStatus = optionsStatus
    form: MediumHeavyForm = {
        heavy: 0,
        piece: 0,
        rate: 0,
        is_active: true
    }

    created () {
        if (this.idEdit) {
            this.form = this.heavy
        }
    }

    @Validations()
    validations () {
        return {
            form: {
                heavy: { required, numeric },
                piece: { required, numeric },
                rate: { required, numeric },
                is_active: { required }
            }
        }
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await MediumHeavyService.update(this.idEdit, this.form)
                } else {
                    await MediumHeavyService.create(this.form)
                }
                alerts.success()
                this.$v.$reset()
                this.form = initItem
                this.$emit('save-success')
            } catch (e) {
                alerts.error('Se ha presentado errores en la operación')
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }
}
